import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NumberPortabilityApiService {

  private readonly numberPortabilityTemplateUrl: string = 'numberPortability/template';
  private readonly numberPortabilityImplementationUrl: string = 'numberPortability/implementation';

  constructor(private http: HttpClient) {}

  public getNumberPortabilityTemplates(): Observable<any> {
    return this.http.get(this.numberPortabilityTemplateUrl);
  }

  public getNumberPortabilityImplementations(): Observable<any> {
    return this.http.get(this.numberPortabilityImplementationUrl).pipe(map((item: any) => {
      item.forEach((implementation) => {
        implementation.params.forEach((param) => {
          if (param.type === 'numberType') {
            param.value = parseInt(param.value, 10);
          } else if (param.type === 'booleanType') {
            param.value = param.value === 'true';
          }
        });
      });

      return item;
    }));
  }

  public deleteNumberPortabilityImplementation(id): Observable<any> {
    return this.http.delete(`${this.numberPortabilityImplementationUrl}/${id}`);
  }

  public editNumberPortabilityImplementation(id, numberPortabilityImplementation): Observable<any> {
    return this.http.put(`${this.numberPortabilityImplementationUrl}/${id}`, numberPortabilityImplementation);
  }

  public addNumberPortabilityImplementation(numberPortabilityImplementation): Observable<any> {
    return this.http.post(this.numberPortabilityImplementationUrl, numberPortabilityImplementation);
  }
}
